export const breakpoints = {
  values: {
    mobileSmall: 0, // mobileSmall
    mobilePortrait: 479, // mobilePortrait
    mobileLandscape: 767, // mobileLandscape
    tablet: 991, // tablet
    desktopSmall: 1252, // desktopSmall
    desktopLarge: 1440, // desktopLarge
  },
};



// WEBPACK FOOTER //
// ./js/components/helpers/breakpoints.js